import { useState, useEffect } from 'react';

let isKeyboardNav = false;
const listeners = new Set<(isKeyboard: boolean) => void>();

const notify = () => listeners.forEach(listener => listener(isKeyboardNav));

if (typeof window !== 'undefined') {
  const onKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Tab' && !isKeyboardNav) {
      isKeyboardNav = true;
      notify();
    }
  };

  const onPointerDown = () => {
    if (isKeyboardNav) {
      isKeyboardNav = false;
      notify();
    }
  };

  window.addEventListener('keydown', onKeyDown, { passive: true });
  window.addEventListener('mousedown', onPointerDown, { passive: true });
  window.addEventListener('touchstart', onPointerDown, { passive: true });
}

export function useIsKeyboardNavigation(): boolean {
  const [isKeyboard, setIsKeyboard] = useState(isKeyboardNav);

  useEffect(() => {
    const listener = (val: boolean) => setIsKeyboard(val);
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, []);

  return isKeyboard;
}
